import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const SYSTEM: AppRouteRecordRaw = {
  path: '/system',
  name: 'system',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '系统管理',
    icon: 'icon-settings',
    requiresAuth: true,
    order: 7,
  },
  children: [
    {
      path: 'user',
      name: 'SystemUser',
      component: () => import('@/views/system/user/index.vue'),
      meta: {
        locale: '用户管理',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'menu',
      name: 'Menu',
      component: () => import('@/views/system/menu/index.vue'),
      meta: {
        locale: '菜单管理',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'role',
      name: 'Role',
      component: () => import('@/views/system/role/index.vue'),
      meta: {
        locale: '角色管理',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'invoice-email-task',
      name: 'InvoiceEmailTaskDiagnostic',
      component: () => import('@/views/system/invoice-email-task/index.vue'),
      meta: {
        locale: '邮件任务诊断',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    // 其他系统管理子菜单...
  ],
};

export default SYSTEM;
